import React from 'react';
import { STANDARD_PRICE } from '../../data/mock';

const features = (editedPhotos) => [
  '1 hour session',
  `${editedPhotos} edited photos`,
  '30–60 second highlight video',
  'Private online gallery, available for 3 months',
  'Delivered within 10 days',
  'Location, timing and outfits guidance',
  'Gentle direction through the session'
];

const PACKAGES = [
  { id: 'classic', name: 'Classic', price: STANDARD_PRICE, features: features(20) },
  { id: 'signature', name: 'Signature', price: 1400, features: features(30) }
];

const NOTES = [
  {
    id: 'studio-rental',
    title: 'Studio Rental',
    text: 'Studio rental is not included and is paid separately.'
  },
  {
    id: 'outside-dubai',
    title: 'Outside Dubai',
    text: 'Additional travel fee applies, depending on location.'
  }
];

export const ServicesSection = ({ onBookSession }) => (
  <section id="services" className="section-spacing bg-[#1a1a1a]">
    <div className="revolt-container">
      <div className="text-center mb-lg">
        <h2 className="section-title">Pricing</h2>
      </div>

      <div className="pricing-grid">
        {PACKAGES.map((pkg, index) => (
          <div key={pkg.id} className={`package-card fade-in-up ${index ? `stagger-${index}` : ''}`} data-testid={`package-${pkg.id}`}>
            <h3 className="package-name">{pkg.name}</h3>
            <div className="package-price">{pkg.price.toLocaleString()} AED</div>
            <ul className="package-features">
              {pkg.features.map((feature, idx) => (
                <li key={`${pkg.id}-feature-${idx}`}>{feature}</li>
              ))}
            </ul>
            <button
              onClick={() => onBookSession(pkg.id)}
              className="hero-cta"
              style={{ padding: '0.8rem 2rem', fontSize: '0.75rem' }}
              data-testid={`package-book-${pkg.id}`}
            >
              Book Now
            </button>
          </div>
        ))}
      </div>

      <h3 className="pricing-addons-title" data-testid="pricing-addons-title">Add-Ons</h3>
      <div className="pricing-notes" data-testid="pricing-notes">
        {NOTES.map(note => (
          <div key={note.id} className="pricing-note" data-testid={`pricing-note-${note.id}`}>
            <h4 className="pricing-note-title">{note.title}</h4>
            <p className="pricing-note-text">{note.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
